// extracted by mini-css-extract-plugin
export default {"statusBadge":"badges_statusBadge__IUQyu","activeIcon":"badges_activeIcon__I3VTc","inactiveIcon":"badges_inactiveIcon__EbEN0"};